import { __assign, __awaiter, __extends, __generator, __rest } from "tslib";
import * as React from 'react';
import { GridContext } from './Grid';
import NeoButton from '../Button';
import { Misc, Utils } from '@singularsystems/neo-core';
import ComponentBase from '../ComponentBase';
import { ColumnHelper } from './ColumnHelper';
var ButtonColumn = /** @class */ (function (_super) {
    __extends(ButtonColumn, _super);
    function ButtonColumn(props) {
        var _this = _super.call(this, props) || this;
        _this.onDelete = _this.onDelete.bind(_this);
        return _this;
    }
    ButtonColumn.prototype.onFirstRender = function () {
        this.section = this.context.section;
        this.item = this.context.currentItem;
    };
    ButtonColumn.prototype.onDelete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var item, mustRemove;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        item = (_a = this.props.item) !== null && _a !== void 0 ? _a : this.item;
                        if (!(item.isNew === false && ((_b = this.props.deleteButton) === null || _b === void 0 ? void 0 : _b.onDeleteExisting) !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.deleteButton.onDeleteExisting(item)];
                    case 1:
                        mustRemove = _c.sent();
                        if (mustRemove) {
                            this.context.dataView.rawItems.removeWithoutTracking(item);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.context.dataView.rawItems.remove(item);
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ButtonColumn.prototype.render = function () {
        this.onRender();
        var _a = this.props, item = _a.item, label = _a.label, showDefaultButtonText = _a.showDefaultButtonText, buttonSize = _a.buttonSize, showDelete = _a.showDelete, editButton = _a.editButton, deleteButton = _a.deleteButton, viewButton = _a.viewButton, childAlignment = _a.childAlignment, hideBelow = _a.hideBelow, hideAbove = _a.hideAbove, alignment = _a.alignment, domProps = __rest(_a, ["item", "label", "showDefaultButtonText", "buttonSize", "showDelete", "editButton", "deleteButton", "viewButton", "childAlignment", "hideBelow", "hideAbove", "alignment"]);
        domProps.className = Utils.joinWithSpaces("neo-grid-button-column", domProps.className);
        domProps.className = ColumnHelper.addCommonClasses(domProps.className, this.props);
        var editButtonDefaults = __assign({}, Misc.Settings.grid.editButton);
        var deleteButtonDefaults = __assign({}, Misc.Settings.grid.deleteButton);
        var viewButtonDefaults = __assign({}, Misc.Settings.grid.viewButton);
        if (!showDefaultButtonText) {
            editButtonDefaults.text = "";
            deleteButtonDefaults.text = "";
            viewButtonDefaults.text = "";
        }
        if (buttonSize) {
            editButtonDefaults.size = buttonSize;
            deleteButtonDefaults.size = buttonSize;
            viewButtonDefaults.size = buttonSize;
        }
        var editButtonOptions = editButton ? Utils.populatePartialWithDefaults(editButton, editButtonDefaults) : null;
        var deleteButtonOptions = (deleteButton || showDelete) ? Utils.populatePartialWithDefaults(deleteButton, deleteButtonDefaults) : null;
        var viewButtonOptions = viewButton ? Utils.populatePartialWithDefaults(viewButton, viewButtonDefaults) : null;
        if (deleteButtonOptions && !deleteButtonOptions.onClick) {
            deleteButtonOptions.onClick = this.onDelete;
        }
        var buttons = React.createElement(React.Fragment, null,
            viewButtonOptions && React.createElement(NeoButton, __assign({}, viewButtonOptions)),
            editButtonOptions && React.createElement(NeoButton, __assign({}, editButtonOptions)),
            deleteButtonOptions && React.createElement(NeoButton, __assign({}, deleteButtonOptions)));
        return (this.section !== "body" ?
            React.createElement("th", __assign({}, domProps), this.section === "header" && label) :
            React.createElement("td", __assign({}, domProps),
                childAlignment === "right" ? buttons : undefined,
                this.props.children instanceof Function ? this.props.children() : this.props.children,
                childAlignment !== "right" ? buttons : undefined));
    };
    ButtonColumn.isColumnComponent = true;
    ButtonColumn.contextType = GridContext;
    return ButtonColumn;
}(ComponentBase));
export { ButtonColumn };
